import React from "react";

const CryotoBasics = () => {
  return (
    <div>
      <h2>Cryoto Basics</h2>
    </div>
  );
};

export default CryotoBasics;
